export default __webpack_public_path__ + "static/media/1819.fbe8bd89.png";